// V3 Types Export
export * from './auth.types';
export * from './project.types';
export * from './file.types';  // ⭐ 파일 관리 타입
export * from './history.types';
export * from './notification.types';

// User Role Mapping
export const UserRoleMap = {
  admin: '관리자',
  user: '일반사용자',
  customer: '고객사',
  partner: '협력사'
} as const;

// 상태값 타입 정의
export type MoldStatus = 'stored' | 'in-use' | 'maintenance' | 'disposed';
export type TransactionType = 'check-out' | 'check-in';
export type AssetType = 'owned' | 'leased' | 'consigned';
export type MoldType = 'injection-trial' | 'injection-production' | 'press' | 'die-casting' | 'forging' | 'other';
export type ProductionSource = 'manual' | 'iot';

// 상태값 매핑
export const MoldStatusMap = {
  stored: '보관중',
  'in-use': '사용중',
  maintenance: '점검중',
  disposed: '폐기'
} as const;

export const MoldTypeMap = {
  'injection-trial': '사출금형(시금형)',
  'injection-production': '사출금형(양산금형)',
  press: '프레스금형',
  'die-casting': '다이캐스팅금형',
  forging: '단조금형',
  other: '기타'
} as const;

export const TransactionTypeMap = {
  'check-out': 'OUT',
  'check-in': 'IN'
} as const;

// 역방향 매핑
export const TransactionDisplayMap = {
  'OUT': 'check-out',
  'IN': 'check-in'
} as const;

// Customer Type (V2 호환)
export interface Customer {
  id?: string;
  name: string;
  type: 'client' | 'partner';
  contact: string;
  phone: string;
  email?: string;
  address?: string;
  logo?: string;              // 로고 이미지 URL
  logoThumbnail?: string;     // 로고 썸네일 (200x200)
  createdAt: any;
  updatedAt: any;
}

export const CustomerTypeMap = {
  client: '고객사',
  partner: '협력사'
} as const;

// V2 호환 타입들 (임시)
export interface Mold {
  id?: string;
  moldNumber: string;
  projectId?: string | null;
  projectNo?: string | null;
  customerId?: string;
  locationId?: string;
  status?: string;
  cavity?: string;              // 캐비티 구성 (예: 1x8, 2x2)
  cavities?: CavityInfo[];      // 캐비티별 제품명 정보
  createdAt?: any;
  updatedAt?: any;
  [key: string]: any;
}

// 캐비티 정보 인터페이스
export interface CavityInfo {
  cavityNumber: number;    // 캐비티 번호 (1, 2, 3, ...)
  productName: string;     // 해당 캐비티의 제품명
}

export interface Location {
  id?: string;
  name: string;
  type: string;
  [key: string]: any;
}

export interface Transaction {
  id?: string;
  moldId: string;
  type: string;
  createdAt?: any;
  [key: string]: any;
}

export interface ProductionLog {
  id?: string;
  moldId: string;
  quantity: number;
  createdAt?: any;
  [key: string]: any;
}
